import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/root/repo/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/article/article-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/create-an-account.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/news/article.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/news/recent-news.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/primitives/button.tsx");
